// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1410":"css/app.7041","2943":"css/admin-app.7041"}[chunkId] + ".css";
};